import handCursorIcon from "../../assets/cursors/hand.png";

type IconProps = { className?: string };

export function IconPen({ className = "wb-tool-icon-btn__svg" }: IconProps) {
  // Как Figma Pen: короткий наконечник
  return (
    <svg className={className} width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M15.8 2.9 20.2 7.8c.55.6.5 1.55-.1 2.1L9.4 19.9c-.35.3-.8.4-1.25.3L3.6 19.1c-.7-.15-1.1-.85-.95-1.55l1.1-4.5c.1-.4.3-.75.6-1L13.7 3c.55-.55 1.5-.6 2.1-.1z" />
      <path d="M14.7 4.4 5.5 16.9" opacity="0.45" />
    </svg>
  );
}

export function IconCursor({ className = "wb-tool-icon-btn__svg" }: IconProps) {
  // Классический курсор (как на референсе): острый нос, короткий поджатый хвостик
  return (
    <svg className={className} width="22" height="22" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden>
      <path d="M6 3.5v14.8l3.6-3.4 2.9 6.6 2.7-1.2-2.9-6.5H19L6 3.5z" />
    </svg>
  );
}

export function IconHand({ className = "wb-tool-icon-btn__svg" }: IconProps) {
  return (
    <img
      src={handCursorIcon}
      className={className}
      width={18}
      height={18}
      alt=""
      aria-hidden
      draggable={false}
      style={{ objectFit: "contain" }}
    />
  );
}

export function IconRect({ className = "wb-tool-icon-btn__svg" }: IconProps) {
  return (
    <svg className={className} width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <rect x="4" y="6" width="16" height="12" rx="2" />
    </svg>
  );
}

export function IconFrame({ className = "wb-tool-icon-btn__svg" }: IconProps) {
  return (
    <svg className={className} width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <rect x="3" y="5" width="18" height="14" rx="1.5" />
      <path d="M3 9h18" />
    </svg>
  );
}

export function IconSticky({ className = "wb-tool-icon-btn__svg" }: IconProps) {
  return (
    <svg className={className} width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      {/* Квадратный стикер с загнутым уголком и строками */}
      <path d="M6 4h9l5 5v11a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z" />
      <path d="M15 4v5h5" />
      <path d="M8 13h8M8 17h5" />
    </svg>
  );
}

export function IconImage({ className = "wb-tool-icon-btn__svg" }: IconProps) {
  return (
    <svg className={className} width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <circle cx="9" cy="10" r="1.5" fill="currentColor" stroke="none" />
      <path d="m21 17-5-5-4 4-3-3-6 6" />
    </svg>
  );
}

export function IconEraser({ className = "wb-tool-icon-btn__svg" }: IconProps) {
  return (
    <svg className={className} width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21" />
      <path d="M22 21H7" />
      <path d="m5 11 9 9" />
    </svg>
  );
}

export function IconLine({ className = "wb-tool-icon-btn__svg" }: IconProps) {
  return (
    <svg className={className} width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden>
      <line x1="5" y1="19" x2="19" y2="5" />
    </svg>
  );
}

export function IconArrow({ className = "wb-tool-icon-btn__svg" }: IconProps) {
  // Простая стрелка вправо (как в стоковых наборах)
  return (
    <svg className={className} width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M5 12h14" />
      <path d="m13 5 7 7-7 7" />
    </svg>
  );
}

export function IconText({ className = "wb-tool-icon-btn__svg" }: IconProps) {
  return (
    <svg className={className} width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <polyline points="4 7 4 4 20 4 20 7" />
      <line x1="9" y1="20" x2="15" y2="20" />
      <line x1="12" y1="4" x2="12" y2="20" />
    </svg>
  );
}

export function IconMenu({ className = "wb-tool-icon-btn__svg" }: IconProps) {
  return (
    <svg className={className} width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden>
      <path d="M4 6h16M4 12h16M4 18h16" />
    </svg>
  );
}
